import React from "react";

// Import necessary components
import SplashCursor from "../content/Animations/SplashCursor";

import "../globals.css";
import { RainbowButton } from "../components/ui/RainbowButtonComp";
import { SparklesCore } from "../components/ui/SparklesComp";
import { AnimatedText } from "../components/ui/TextUnderline";
import { AnimatedShinyText, AnimatedShinyTextDemo } from "../components/ui/AnimatedShinyText";

import BracketLogo from "../assets/bracket_logo.png";
import LinkedinIcon from "../assets/linkedin-logo.png"; 
import EmailIcon from "../assets/email_icon.png"; 

const LandingPage = () => {
  const verticalShift = "-2vh"; // Adjustable parameter for shifting content upwards

  return (
    <div
      style={{
        position: "relative",
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        backgroundColor: "rgb(0, 0, 0)", // Dark background for a modern look
        fontFamily: "barlow",
      }}
    >

      {/* Bottom Left Section for Social Links */}
      <div
        style={{
          position: "absolute",
          bottom: "2rem",
          left: "3rem",
          // left: "50%", // Center horizontally
          // transform: "translateX(-50%)", // Center alignment          
          display: "flex",
          gap: "1.5rem",
          alignItems: "center",
          zIndex: 20,
        }}
      >
        <a
          href="https://www.linkedin.com/company/bracket-sh/" // Replace with your LinkedIn profile URL
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
          }}
        >
          <img
            src={LinkedinIcon}
            alt="LinkedIn"
            style={{
              height: "1.8rem",
              width: "1.8rem",
              filter: "invert(100%)", // Makes the icon white
              cursor: "pointer",
            }}
          />
        </a>
        <a
          href="mailto:dhruv@bracket.sh" // Replace with your email address
          style={{
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
          }}
        > 
          <img
            src={EmailIcon}
            alt="Email"
            style={{
              height: "1.8rem",
              width: "1.8rem",
              filter: "invert(100%)", // Makes the icon white
              cursor: "pointer",
            }}
          />
        </a>
      </div>

      {/* Copyright Section */}
      <div
        style={{
          position: "absolute",
          bottom: "2rem",
          right: "2rem",
          // left: "1rem",          
          display: "flex",
          color: "#ffffff", // Updated to white color
          fontSize: "0.875rem",
          fontFamily: "barlow",
          textAlign: "right",
          userSelect: "none",
          alignItems: "center",
          zIndex: 20,          
        }}
      >
        © {new Date().getFullYear()} BRACKET. All rights reserved.
      </div>
       


      {/* Background Animation */}
      <SplashCursor />

      {/* Main Content */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          position: "relative",
          gap: "4.0rem",
          transform: `translateY(${verticalShift})`, // Shift content upward
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            zIndex: 10,
            marginRight: "2.5rem",
            userSelect: "none",
            gap: "1rem", // Ensure proper spacing between logo and text
          }}
        >
          <img
            src={BracketLogo} // Replace with the path to your logo file
            alt="Bracket Logo"
            style={{
              height: "clamp(5rem, 10vw, 7.5rem)", // Responsive logo size
              marginRight: "0.5rem",
              position: "relative",
              zIndex: 1, // Ensures the image does not overlap the text
            }}
          />
          <h1
            style={{
              fontFamily: "barlow",
              fontSize: "clamp(2.5rem, 5vw, 4.0rem)", // Responsive font size for title
              color: "#ffffff",
              fontWeight: "bold",
              textAlign: "center",
              zIndex: 2,
              margin: 0, // Remove default margins for consistent alignment
            }}
          >
            BRACKET
          </h1>
        </div>

        <div
          style={{
            fontFamily: "barlow",
            fontSize: "2.0rem", // Slightly smaller font size for subtitle
            color: "#ffffff",
            fontWeight: "normal",
            textAlign: "center",
            marginLeft: "1.5rem",
            marginTop: "-1.5rem", // Adjust spacing between title and subtitle
            userSelect: "none", // Prevent text selection
          }}
        >
          <RainbowButton
            style={{
              position: "absolute", // Makes it stick to a specific position
              top: "25%",
              left: "50%", // Center horizontally
              transform: "translateX(-50%)", // Center alignment
              fontSize: "clamp(1.3rem, 1.8vw, 1.8rem)", // Responsive font size for button text
              padding: "clamp(1.3rem, 2.0vw, 1.8rem) clamp(2rem, 3vw, 3rem)", // Responsive padding
              zIndex: 10, // Ensure it stays above other elements,
              userSelect: "none", // Prevent text selection
              whiteSpace: "nowrap", // Prevent text wrapping
            }}
          >
            ✨&nbsp;&nbsp;&nbsp;<strong>53.2%&nbsp;</strong> on SWE-Bench Verified &nbsp;
          </RainbowButton>
        </div>

        {/* Sparkles Section */}
        <div
          className="w-full h-[20rem] flex flex-col items-center justify-center overflow-hidden rounded-md"
          style={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%", // Matches the content width
            height: "60%",
            top: "7%",
            margin: "0 auto",
          }}
        >
          <div className="absolute inset-x-[12.5%] top-0 bg-gradient-to-r from-transparent via-indigo-500 to-transparent h-[2px] w-3/4 blur-sm" />
          <div className="absolute inset-x-[12.5%] top-0 bg-gradient-to-r from-transparent via-indigo-500 to-transparent h-px w-3/4" />
          <div className="absolute inset-x-[12.5%] top-0 bg-gradient-to-r from-transparent via-sky-500 to-transparent h-[5px] w-3/4 blur-sm" />
          <div className="absolute inset-x-[12.5%] top-0 bg-gradient-to-r from-transparent via-sky-500 to-transparent h-px w-3/4" />

          <SparklesCore
            background="transparent"
            minSize={0.5}
            maxSize={1.5}
            height={5} // Reduced height for particles
            particleDensity={15} // Adjust density for subtlety
            className="w-full h-full"
            particleColor="#FFFFFF"
          />

          <p
            style={{
              position: "absolute",
              fontFamily: "barlow",
              fontSize: "2.0rem",
              color: "#ffffff",
              textAlign: "center",
              zIndex: 30,
              top: "0%",
              userSelect: "none", // Prevent text selection
            }}
          >
            <div
              style={{
                maxWidth: "100vw", // Restrict the maximum width
                margin: "0 auto", // Center the container horizontally
                textAlign: "center", // Center-align the text
                color: "#ffffff", // Text color
                fontSize: "clamp(1.5rem, 2.5vw, 2rem)", // Responsive font size
                lineHeight: "clamp(1.8rem, 3vw, 2.5rem)", // Responsive line height
                padding: "clamp(1rem, 3vw, 2rem)", // Responsive padding
                overflow: "hidden", // Ensure no unnecessary scrollbars
                wordWrap: "break-word", // Break words to fit inside the container
                padding: "5%", // Padding for the text
              }}
            >
              <AnimatedText text="A Breakthrough in Codebase Understanding" /> <br/>
              <p style={{ fontSize: "clamp(1.5rem, 1.8vw, 1.8rem)", lineHeight: "clamp(2.2rem, 3.5vw, 3.2rem)", maxWidth: "80%", margin: "0 auto", marginTop: "2%"}}>
                BRACKET builds an intermediate representation of large codebases, enabling agents to work at higher levels of layered abstractions.<br></br> This has unlocked usecases that were previously not possible.
              </p>
            </div>
          </p>
        </div>
      </div>

      {/* Bottom Section */}
      <div
        style={{
          position: "absolute",
          bottom: "5rem",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        className="cta-section"
      >
        <div
          style={{
            padding: "0.6rem 3rem",
            borderRadius: "15px",
            background: "", // Updated gradient
            color: "#ffffff",
            fontWeight: "500",
            fontSize: "1.55rem",
            cursor: "pointer",
            transition: "all 0.3s ease-in-out",
            boxShadow: "0px 0px 60px rgba(4, 165, 233, 1.8)",
            border: "2px solid rgba(0, 0, 0, 0.1)", // Subtle border for definition
          }}
          data-tally-open="3EvOoN" // Replace with your form ID
          data-tally-emoji-text="👋" // Emoji text for the popup
          data-tally-emoji-animation="wave" // Emoji animation style
        >
          <img
            src={BracketLogo}
            alt="Bracket Logo"
            style={{
              height: "2.5rem",
              marginRight: "0.5rem",
              display: "inline-block",
              verticalAlign: "middle",
            }}
          />
          Request Early Access
        </div>
      </div>

      {/* Responsive Styles */}
      <style jsx>{`
        @media (max-width: 768px) {
          .cta-section {
            bottom: 1rem; /* Adjust button position */
          }
          div[style*="fontSize: clamp(1.5rem, 2.5vw, 2rem)"] {
            margin-bottom: 2rem; /* Add spacing below text */
          }
        }
      `}</style>
    </div>
  );
};

export default LandingPage;
